<template>
    <div>
        <a-card :bordered="false">
            <a-form-model ref="oddsForm" :model="form" layout="horizontal" :label-col="{span:2}" :wrapper-col="{span:15}" autoComplete="off">
                <a-tabs default-active-key="1">
                    <a-tab-pane key="1" tab="和值" :forceRender="true">
                        <a-form-model-item v-for="item in hezhiBetList" :label="item.name" :prop="'item' + item.id" :key="item.id"
                            :rules="[{ validator: validateItem, trigger: 'blur' }]"
                        >
                            <a-input-group compact>
                                <a-input addon-before="赔率" style="width:200px"
                                    v-model="form['item' + item.id].odds"
                                />
                                <a-input addon-before="限低下注" style="width: 200px; margin-left:15px;"
                                    v-model="form['item' + item.id].min"
                                />
                                <span style="margin:0 10px">~</span>
                                <a-input addon-before="最高出价" style="width: 200px;"
                                     v-model="form['item' + item.id].max"
                                />
                            </a-input-group>
                        </a-form-model-item>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="百值" :forceRender="true">
                        <a-form-model-item v-for="item in baizhiBetList" :label="item.name" :prop="'item' + item.id" :key="item.id"
                            :rules="[{ validator: validateItem, trigger: 'blur' }]"
                        >
                            <a-input-group compact>
                                <a-input addon-before="赔率" style="width:200px"
                                         v-model="form['item' + item.id].odds"
                                />
                                <a-input addon-before="限低下注" style="width: 200px; margin-left:15px;"
                                         v-model="form['item' + item.id].min"
                                />
                                <span style="margin:0 10px">~</span>
                                <a-input addon-before="最高下注" style="width: 200px;"
                                         v-model="form['item' + item.id].max"
                                />
                            </a-input-group>
                        </a-form-model-item>
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="十值" :forceRender="true">
                        <a-form-model-item v-for="item in shizhiBetList" :label="item.name" :prop="'item' + item.id" :key="item.id"
                            :rules="[{ validator: validateItem, trigger: 'blur' }]"
                        >
                            <a-input-group compact>
                                <a-input addon-before="赔率" style="width:200px"
                                         v-model="form['item' + item.id].odds"
                                />
                                <a-input addon-before="限低下注" style="width: 200px; margin-left:15px;"
                                         v-model="form['item' + item.id].min"
                                />
                                <span style="margin:0 10px">~</span>
                                <a-input addon-before="最高出价" style="width: 200px;"
                                         v-model="form['item' + item.id].max"
                                />
                            </a-input-group>
                        </a-form-model-item>
                    </a-tab-pane>
                    <a-tab-pane key="4" tab="个值" :forceRender="true">
                        <a-form-model-item v-for="item in gezhiBetList" :label="item.name" :prop="'item' + item.id" :key="item.id"
                            :rules="[{ validator: validateItem, trigger: 'blur' }]"
                        >
                            <a-input-group compact>
                                <a-input addon-before="赔率" style="width:200px"
                                         v-model="form['item' + item.id].odds"
                                />
                                <a-input addon-before="限低下注" style="width: 200px; margin-left:15px;"
                                         v-model="form['item' + item.id].min"
                                />
                                <span style="margin:0 10px">~</span>
                                <a-input addon-before="最高出价" style="width: 200px;"
                                         v-model="form['item' + item.id].max"
                                />
                            </a-input-group>
                        </a-form-model-item>
                    </a-tab-pane>
                </a-tabs>

                <a-form-model-item :wrapper-col="{ span: 15, offset: 2 }">
                    <a-button type="primary" :loading="submitLoading" style="width:120px;" @click="onSubmit">
                        提交
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>
</template>

<script>
import { lottoBetList, lottoBetUpdate } from "@/api/op/lottoBet";

export default {
    data() {
        return {
            hezhiBetList: [],
            baizhiBetList: [],
            shizhiBetList: [],
            gezhiBetList: [],
            form: {},
            submitLoading: false
        }
    },
    created() {
        this.getFromData();
    },
    methods: {
        getFromData() {
            lottoBetList(0).then(res => {
                this.hezhiBetList = res.data.hezhiBetList;
                this.baizhiBetList = res.data.baizhiBetList;
                this.shizhiBetList = res.data.shizhiBetList;
                this.gezhiBetList = res.data.gezhiBetList;
                this.form = res.data.form;
            });
        },
        onSubmit() {
            this.$refs.oddsForm.validate(valid => {
                if(valid) {
                    this.submitLoading = true;
                    lottoBetUpdate(this.form, 0).then(()=>{
                        this.$message.success('修改成功');
                    }).finally(() => {
                        this.submitLoading = false;
                    });
                } else {
                    this.$message.error("表单填写错误，请校验后再提交");
                    return false;
                }
            });
        },
        validateItem(rule, value, callback) {
            if (!value || value.odds === '' || value.odds === null || value.odds === undefined) {
                callback(new Error('赔率不能为空'));
                return;
            }
            if (!value.min) {
                callback(new Error('限低下注不能为空'));
                return;
            }
            if (!value.max) {
                callback(new Error('最高下注不能为空'));
                return;
            }

            const minNum = Number(value.min);
            const maxNum = Number(value.max);
            if (isNaN(minNum) || isNaN(maxNum)) {
                callback(new Error('请填写有效数字'));
                return;
            }
            if (minNum > maxNum) {
                callback(new Error('限低下注不能高于最高下注'));
                return;
            }

            if(value.min <= 0 || value.max <= 0) {
                callback(new Error('限红金额必须大于0'));
                return;
            }
            callback();
        }
    }
}
</script>

<style lang="less" scoped>

</style>
